<script setup>
import http from "@/js/http";
import { actionSheetController, IonPage, modalController, popoverController } from "@ionic/vue";
import store from "@/js/store";
import { useRouter } from "vue-router";
import { defineProps, nextTick, onMounted, reactive, ref } from "vue";
import ChildMemu from "./components/ChildMemu.vue";
import Template1 from "@/views/grammar/newGrammar/components/Template1.vue";
import Template2 from "@/views/grammar/newGrammar/components/Template2.vue";
import Template3 from "@/views/grammar/newGrammar/components/Template3.vue";
import Template4 from "@/views/grammar/newGrammar/components/Template4.vue";
import Template5 from "@/views/grammar/newGrammar/components/Template5.vue";
import PageDialog from "@/components/PageDialog.vue";
import { alertModal } from "@/main";
import { insetIconPen } from "@/views/grammar/js/TagAnalysis";

const router = useRouter();

const props = defineProps(["subChapterId", "chapterId"]);

const subChapterId = ref(props.subChapterId);

const currentLinkStep = ref(0);

const stepOptions = reactive({
  0: "引入",
  1: "学练",
  2: "检测",
  3: "总结",
});
const pageNum = ref(1);

const total = ref(0);

const templateCode = ref();

const templateData = ref();

const childMenus = ref([]);

const updateKey = ref(0);

const paginationQuery = ref({
  pageNo: 1,
  pageSize: 99,
  chapterId: props.chapterId,
});

const isPrepare = reactive(sessionStorage.getItem("isPrepare")); //陪练备课状态不做数据提交

const saveRecord = ref("");

//结束学习并保存学习进度
function finishedStudy(val) {
  saveRecord.value = val;
  if (!isPrepare) {
    const aptmId = store.getAppointment().aptmId;
    const studentId = store.getAppointment().studentId;
    let dataForm = {
      page: pageNum.value,
      pageId: subChapterId.value,
      chapterId: props.chapterId,
      finished: 1,
      aptmId: aptmId,
      studentId: studentId,
    };
    http
      .post("/grammar/endGrammarStudy", dataForm)
      .then((res) => {
        if (res.data.success) {
          if (saveRecord.value === "back") {
            modalController.dismiss();
          } else if (saveRecord.value === "save") {
            openConfirmModal("学习进度保存成功，是否创建抗遗忘？");
          }
        }
      })
      .finally(() => {
        popoverController.dismiss();
      });
  } else {
    if (val) {
      //教练备课状态下不调api
      modalController.dismiss();
    }
  }
}

async function showMenu() {
  const modal = await modalController.create({
    component: ChildMemu,
    componentProps: { childMenus: childMenus.value, subChapterId: templateData.value.subChapterId },
    cssClass: "menu_half_bottom",
  });
  await modal.present();
  modal.onDidDismiss().then(({ data }) => {
    if (data) {
      subChapterId.value = data.subChapterId;
      getTemplateContent();
    }
  });
}

//获取模板内容
async function getTemplateContent() {
  if (!subChapterId.value) return;
  try {
    const { data } = await http.get(
      "/chapter/subchapter/subChapterInfo?subChapterId=" + subChapterId.value
    );
    if (data.code === 200) {
      templateData.value = data.data;
      templateCode.value = data.data.templateCode;
      updateKey.value = templateData.value.subChapterId;
      pageNum.value = parseInt(data.data.pageNumber);
      currentLinkStep.value = data.data.linkTitle;
      nextTick(() => {
        insetIconPen(".template-article");
        insetIconPen(".explanation-box");
      });
    }
  } catch (e) {}
}

//获取页码数据
async function getPaginationData() {
  try {
    const { data } = await http.post(
      "/chapter/subchapter/getChapterDirectoryInfo",
      paginationQuery.value
    );
    if (data.code === 200) {
      total.value = data.data.total;
      childMenus.value = data.data.list;
    }
  } catch (e) {}
}

//上一页
function handlePrevPage() {
  if (pageNum.value === 1) return false;
  subChapterId.value = templateData.value.preSubChapterId;
  getTemplateContent();
}

//下一页
async function handlenextPage() {
  subChapterId.value = templateData.value.nextSubChapterId;
  await getTemplateContent();
  await finishedStudy();
}

//退出
function endStudy() {
  if (!isPrepare) {
    const aptmId = store.getAppointment().aptmId;
    const studentId = store.getAppointment().studentId;
    let dataForm = {
      page: pageNum.value,
      pageId: subChapterId.value, //副章节id
      chapterId: props.chapterId,
      finished: undefined,
      aptmId: aptmId,
      studentId: studentId,
    };
    http.post("/grammar/endGrammarStudy", dataForm).then((res) => {
      if (res.data.success) {
        openConfirmModal();
      }
    });
  } else {
    modalController.dismiss();
  }
}

// 询问是否创建抗遗忘
async function openConfirmModal(msg) {
  const modal = await modalController.create({
    id: "PageDialog",
    component: PageDialog,
    componentProps: {
      title: "",
      message: msg ? msg : "本次课程学习已结束，是否创建抗遗忘？",
      type: "hasCancel",
    },
    cssClass: "center_modal_controller_class3",
    backdropDismiss: false,
  });
  await modal.present().then(() => {});
  modal.onDidDismiss().then(async ({ data }) => {
    if (data === "NEXT") {
      let aptmId = store.getAppointment().aptmId;
      showTeacherSelect(aptmId);
    } else if (data !== "NEXT" && saveRecord.value !== "save") {
      modalController.dismiss();
    }
  });
}

const timeout = ref(false);

//创建抗遗忘
function requestGenerateForget(params) {
  return new Promise((resolve, reject) => {
    if (!timeout.value) {
      timeout.value = true;
      setTimeout(() => {
        timeout.value = false;
      }, 500);
      if (params.aptmId == 0) {
        resolve("");
      } else {
        http
          .post("/forget/generateForget", params)
          .then(async (res) => {
            if (res.data.success) {
              await alertModal("21天抗遗忘创建成功。");
              resolve("");
            }
          })
          .catch(() => {
            reject("");
          });
      }
    }
  });
}

//显示选择资料列表
async function showTeacherSelect(aptmId) {
  return new Promise(async (resolve) => {
    let buttons = [];
    for (let i = 5; i < 24; i++) {
      let fill = i < 10 ? "0" : "";
      let time1 = fill + i + ":00";
      let time2 = fill + i + ":30";
      let params1 = { aptmId: aptmId, startTime: time1 };
      let params2 = { aptmId: aptmId, startTime: time2 };
      buttons.push({
        text: time1,
        handler: async () => {
          await requestGenerateForget(params1);
          if (saveRecord.value !== "save") {
            modalController.dismiss();
          }
          resolve();
        },
      });

      buttons.push({
        text: time2,
        cssClass: "teacherSelectButtons",
        handler: async () => {
          await requestGenerateForget(params2);
          if (saveRecord.value !== "save") {
            modalController.dismiss();
          }
          resolve();
        },
      });
    }
    const actionSheet = await actionSheetController.create({
      header: "选择抗遗忘时间 ",
      buttons: buttons,
      backdropDismiss: false,
    });

    await actionSheet.present();
  });
}

//自动创建抗遗忘
async function createForget() {
  const appointment = store.getAppointment();
  const params = {
    aptmId: appointment.aptmId,
    startTime: appointment.beginTime,
  };
  http.post("/forget/generateForget", params);
}

onMounted(() => {
  getTemplateContent();
  getPaginationData();
  if (!isPrepare) {
    createForget();
  }
});
</script>

<template>
  <ion-page class="grammar-wrapper">
    <div class="grammar-wrapper_header">
      <img
        class="icon-back"
        src="@/assets/grammar/back.svg"
        alt=""
        @click="finishedStudy('back')"
      />
      <img class="icon-menu" src="@/assets/grammar/menu.svg" alt="" @click="showMenu" />
      <!--   进度   -->
      <div class="step-box">
        <span
          v-for="(title, step) in stepOptions"
          :key="step"
          class="step-box_item"
          :class="currentLinkStep < step && pageNum !== total ? 'op-5' : ''"
        >
          <img
            v-if="currentLinkStep == step && currentLinkStep !== 3"
            class="icon-step"
            src="@/assets/grammar/current-step.svg"
            alt=""
          />
          <img
            v-if="currentLinkStep > step || currentLinkStep === 3"
            class="icon-step"
            src="@/assets/grammar/finish-step.svg"
            alt=""
          />
          <img
            v-if="currentLinkStep < step && pageNum !== total"
            class="icon-step op-5"
            src="@/assets/grammar/not-finish-step.svg"
            alt=""
          />
          {{ title }}
          <img v-if="step < 3" class="icon-line" src="@/assets/grammar/line-step.png" alt="" />
        </span>
      </div>
    </div>
    <div v-if="templateData" class="grammar-wrapper_title">{{ templateData.subsectionName }}</div>
    <div class="grammar-wrapper_content">
      <div class="content-inner">
        <Template1 v-if="templateCode === '001'" :key="updateKey" :template-data="templateData" />
        <Template2 v-if="templateCode === '002'" :key="updateKey" :template-data="templateData" />
        <Template3 v-if="templateCode === '003'" :key="updateKey" :template-data="templateData" />
        <Template4 v-if="templateCode === '004'" :key="updateKey" :template-data="templateData" />
        <Template5 v-if="templateCode === '005'" :key="updateKey" :template-data="templateData" />
      </div>

      <!--  保存进度 -->
      <div v-if="!isPrepare" class="save-record" @click="finishedStudy('save')">
        <div class="pagination">
          <img src="@/assets/grammar/icon-save-record.svg" class="icon-save-record" alt="" />
          <span>保存进度</span>
        </div>
      </div>

      <!--  翻页    -->
      <div class="pagination-content">
        <div class="pagination">
          <img
            src="@/assets/icon-page-prev.png"
            class="icon-page"
            :class="{ disabled: pageNum <= 1 }"
            alt=""
            @click="handlePrevPage()"
          />
          <div class="page-num">
            <span v-if="total" class="white-color">{{ pageNum }}</span>
            <span>/</span>
            <span>{{ total }}</span>
          </div>
          <img
            v-if="pageNum < total"
            src="@/assets/icon-page-next.png"
            class="icon-page"
            alt=""
            @click="handlenextPage()"
          />
          <img
            v-if="pageNum === total"
            src="@/assets/icon-page-exit.png"
            class="icon-page"
            alt=""
            @click="endStudy()"
          />
        </div>
      </div>
    </div>
  </ion-page>
</template>

<style scoped lang="less">
.grammar-wrapper {
  background-color: #055c49;
  justify-content: flex-start;

  &_header {
    height: 2.97rem; //1rem = 14.8px
    color: white;
    padding-left: 0.67rem;
    display: flex;
    align-items: center;

    .icon-back {
      width: 0.4rem;
      height: 0.94rem;
    }

    .icon-menu {
      width: 1.35rem;
      height: 1.35rem;
      margin: 0 1.35rem;
    }

    .step-box {
      font-size: 0.94rem;

      &_item {
        display: inline-flex;
        align-items: center;
      }

      .icon-step {
        width: 0.81rem;
        height: 0.81rem;
        margin-right: 0.3rem;
      }

      .icon-line {
        width: 0.81rem;
        margin: 0 0.6rem;
      }

      .op-5 {
        opacity: 0.5;
      }
    }
  }

  &_title {
    padding: 0 0.67rem;
    margin: 0.67rem 0;
    color: white;
    font-size: 1rem;
  }

  &_content {
    flex: 1;
    width: 100%;
    height: 80%;
    background: #1e6c5b;

    .content-inner {
      width: 100%;
      height: calc(100% - 3.5rem);
      overflow-y: auto;
    }

    .pagination-content,
    .save-record {
      display: flex;
      justify-content: flex-end;
      position: fixed;
      right: 0;
      bottom: 1rem;
      z-index: 99;

      .pagination {
        display: inline-flex;
        justify-content: space-around;
        align-items: center;
        background: #4b897c;
        min-width: 5.6rem;
        height: 1.8rem;
        border-radius: 30px 0 0 30px;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.5);
        padding: 0 0.5rem;
        box-sizing: border-box;

        .page-num {
          padding: 0 0.57rem;
          line-height: 1.8rem;

          .white-color {
            color: white;
          }
        }
      }

      .disabled {
        opacity: 0.2;
        cursor: not-allowed;
      }

      .icon-page {
        width: 1rem;
        height: 1rem;
      }
    }

    .save-record {
      left: 0;
      right: auto !important;

      .pagination {
        border-radius: 0 30px 30px 0;
        font-size: 0.8rem;
        color: #fff;

        .icon-save-record {
          width: 0.87rem;
          height: 0.87rem;
        }
      }
    }
  }
}
</style>
<style>
.menu_half_bottom {
  --height: 70%;
  --max-height: 70%;
  --max-width: 100%;
  --min-height: 70%;
  --min-width: 100%;
  --width: 100%;
  align-items: flex-end;
  --border-radius: 1rem 1rem 0 0;
}

.highlight-orange {
  color: #ff8c00;
}

.highlight-blue {
  color: #299fe5;
}

.highlight-red {
  color: #dc3545;
}

.highlight-yellow {
  color: #ffc107;
}

.highlight-green {
  color: #0dcb8b;
}

.underline {
  border-bottom: 0.01rem solid #333333;
}

.hide-underline-item {
  visibility: hidden;
}

.icon-pen {
  width: 1.21rem;
  height: 1.21rem;
  cursor: pointer;
  vertical-align: sub;
}
</style>
